import type { ComponentType } from "react";
import dynamic from "next/dynamic";
import audio from "../../../public/lotties/audio.json";

// react-lottie pulls in lottie-web, which touches `document` at module load
// time and crashes during SSR / `next build` page-data collection. Load it
// client-only so every consumer of <Loader /> is safe to import statically.
const Lottie = dynamic(() => import("react-lottie"), { ssr: false }) as ComponentType<{
  options: Record<string, unknown>;
  height?: number;
  width?: number;
}>;

interface LoaderProps {
  height?: number;
  width?: number;
}

const Loader = ({ height, width }: LoaderProps) => {
  return (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: audio,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      }}
      height={height}
      width={width}
    />
  );
};

export default Loader;
